import React, { Children } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function BenefitsSection() {
  const benefits = ['Vas a dejar de vivir en control constante', 'Vas a bajar tu tensión física y mental', 'Vas a volver a sentirte liviana', 'Vas a reconectar con tu intuición', 'Vas a dejar de sobrepensar todo', 'Vas a aprender a recibir sin culpa'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="py-24 bg-white" data-id="element-21">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <FadeIn data-id="element-23">
          <h2 className="text-3xl md:text-5xl font-serif text-brown text-center mb-16" data-id="element-24">
            Lo que va a cambiar en ti
          </h2>
        </FadeIn>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-25">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="flex items-center p-4 bg-cream/30 rounded-2xl border border-gold/10" data-id="element-26">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center mr-4" data-id="element-27">
                <Check className="w-5 h-5 text-gold-dark" data-id="element-28" />
              </div>
              <p className="text-lg text-brown/80 font-medium" data-id="element-29">{benefit}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}